import { useState } from "react";
import { getBackendUrl } from "@/utils/environment";

/**
 * Hook to get backend URL
 * 
 * Uses centralized environment detection from @/utils/environment
 */
export const useGetBackendUrl = () => {
  const [backendUrl] = useState<string>(() => getBackendUrl());
  return backendUrl;
};
